import { FeedbackBanner } from "@hamlak/ui";
import { feedbackUrl, type FeedbackFrom } from "@/config/links";
import { platform } from "@/platform";
import { t } from "@/i18n/ko";

/** 의견 배너(AC0-315). 앱은 Custom Tabs·SFSafariViewController, 웹은 새 탭으로 익명 의견 페이지를 연다. */
export function FeedbackEntry({ from, className }: { from: FeedbackFrom; className?: string }) {
  return (
    <FeedbackBanner
      className={className}
      title={t("feedback.title")}
      description={t("feedback.description")}
      data-testid="feedback-banner"
      onClick={() => void platform.browser.open(feedbackUrl(from))}
    />
  );
}
